import { CommonModule, DatePipe } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatAutocompleteModule } from '@angular/material/autocomplete';
import { MatRadioModule } from '@angular/material/radio';
import { AppDialogComponent } from './components/app-dialog/app-dialog.component';
import { CustomTooltipComponent } from './components/custom-tooltip/custom-tooltip.component';
import { ClickOutsideDirective } from './directives/clickOutside';
import { AutocompleteOffDirective } from './directives/autocomplete-off.directive';
import { CustomTooltipRendererDirective } from './directives/custom-tooltip-renderer.directive';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { NumbersOnlyDirective } from './directives/numbers-only.directive';
import { MatSelectModule } from '@angular/material/select';
import { RestrictSpecialCharatersDirective } from './directives/restrict-special-charaters.directive';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { NgxSpinnerModule } from 'ngx-spinner';
import { DateTimeService } from './services/date-time.service';
import { NgMultiSelectDropDownModule } from 'ng-multiselect-dropdown';
import { ScrollingModule } from '@angular/cdk/scrolling';
import { BannedInactivePlayerComponent } from './components/banned-inactive-player/banned-inactive-player.component';
import { TranslocoRootModule } from '../transloco/transloco-root.module';
import { CarouselModule } from 'primeng/carousel';import { NoDataComponent } from './components/no-data/no-data.component';
import { MenusComponent } from './components/menus/menus.component';

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    MatAutocompleteModule,
    MatRadioModule,
    MatFormFieldModule,
    MatInputModule,
    MatSelectModule,
    MatDatepickerModule,
    MatCheckboxModule,
    NgMultiSelectDropDownModule,
    NgxSpinnerModule,
    ScrollingModule,
    TranslocoRootModule,
    CarouselModule
  ],
  exports: [
    FormsModule,
    ReactiveFormsModule,
    MatAutocompleteModule,
    MatRadioModule,
    ClickOutsideDirective,
    AutocompleteOffDirective,
    MatFormFieldModule,
    MatInputModule,
    NumbersOnlyDirective,
    MatSelectModule,
    RestrictSpecialCharatersDirective,
    MatDatepickerModule,
    MatCheckboxModule,
    NgMultiSelectDropDownModule,
    NgxSpinnerModule,
    ScrollingModule,
    BannedInactivePlayerComponent,
    CarouselModule,
    NoDataComponent
  ],
  declarations: [
    CustomTooltipComponent,
    ClickOutsideDirective,
    CustomTooltipRendererDirective,
    AppDialogComponent,
    NumbersOnlyDirective,
    AutocompleteOffDirective,
    RestrictSpecialCharatersDirective,
    BannedInactivePlayerComponent,
    NoDataComponent,
    MenusComponent
  ],
  providers: [
    DateTimeService,
    DatePipe
]
})
export class SharedModule {}
